import axiosInstance from "../../apiAxios/axiosInstance";

export const BrandList = async (payload) => {
  const response = await axiosInstance.post("/vendor/brand-list", payload);
  return response.data;
};
export const ActiveBrandList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-brand-list",payload);
   return resposne.data
};
export const AddBrand = async (payload) => {
  const response = await axiosInstance.post("/vendor/brand-store", payload);
  return response.data;
};

export const ViewBrand = async (payload) => {
  const response = await axiosInstance.post("/vendor/brand-show", payload);
  return response.data;
};

export const UpdateBrand = async (payload) => {
  const response = await axiosInstance.post("/vendor/brand-update", payload);
  return response.data;
};

export const DeleteBrand = async (payload) => {
  const response = await axiosInstance.post("/vendor/brand-delete", payload);
  return response.data;
};

export const BrandChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/brand-status-update",
    payload
  );
  return response.data;
};